import { gql } from '@apollo/client'
import type { UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import type { PurchaseOrder, StateTransitionArgs } from '@ztechapps/common.contract'
import { purchaseOrderFragment } from './graphql'

export const changePurchaseOrderStatusQuery = gql`
  ${purchaseOrderFragment}
  mutation changePurchaseOrderStatus($input: StateTransitionArgs!) {
    changePurchaseOrderStatus(input: $input) {
      ...purchaseOrderFragment
    }
  }
`

export const useChangePurchaseOrderStatus = (args?: Omit<UseMutationProps, 'query'>) => {
  return useMutation<{ changePurchaseOrderStatus: PurchaseOrder }, StateTransitionArgs<PurchaseOrder>>({
    query: changePurchaseOrderStatusQuery,
    ...args,
  })
}
